import { useEffect, Fragment } from 'react';
import dashboard_dark from '../../assets/images/dashboard_dark.png';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import bell from '../../assets/images/bell.svg';
import { all as allBooks, show as singleBook } from '../../Store/api/books';
import { byBook as gatActivitiesByBook } from '../../Store/api/activities';
import { ProfileDropdown } from '../../shared/ProfileDropdown';

const Navbar = ({ sideBarEvent = 'overview', setSideBarEvent }) => {
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const from = params.get('from');
  const bookId = params.get('bookId');
  const auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(
      allBooks({
        onSuccess: (res) => {
          dispatch(
            singleBook({
              id: res.data.data[0]._id,
              onSuccess: (res) => {},
            })
          );
          dispatch(
            gatActivitiesByBook({
              id: res.data.data[0].activitiesSet || !auth.token ? res.data.data[0]._id : res.data.data[0].parentBook,
              onSuccess: (res) => {},
            })
          );
        },
      })
    );
  }, [auth.token]);

  return (
    <nav className='navbar navbar-default dashboard_header'>
      <div className='navbar-header'>
        <h1 className='hi_user'>
          {sideBarEvent === 'overview' ? (
            <Fragment>Welcome back professor {user.firstName}</Fragment>
          ) : (
            <Fragment>
              {user.firstName}'s {sideBarEvent}
            </Fragment>
          )}
        </h1>
        <div className='right_bar'>
          <ul className='d-flex align-items-center gap-3'>
            <li className='m-0 cursor'>
              {from === 'auth' ? (
                <Link to={`/create/${bookId}`}>
                  <img src={dashboard_dark} width={24} height={24} alt='grid' />
                </Link>
              ) : (
                <Link to={-1}>
                  <img src={dashboard_dark} width={24} height={24} alt='grid' />
                </Link>
              )}
            </li>
            <li className='m-0 cursor'>
              <img src={bell} alt='grid' className='bell' width={24} height={24} />
            </li>
            <li className='m-0 cursor'>
              <ProfileDropdown user={user} />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
